module.exports = __webpack_public_path__ + "img/discount.626aae56.png";